module.exports = __webpack_public_path__ + "img/COM-A-2-I.17f39b8e.png";